import {loadComponent} from '../components/LoadComponent/LoadComponent'

export const routes = [
    {
        path: '/',
        exact: true,
        render: (props) => loadComponent(() => import('../containers/Dashboard/Dashboard'), props),
    },
    {
        path: '/page/:url',
        exact: false,
        render: (props) => loadComponent(() => import('../containers/Page/Page'), props),
    },
    {
        path: '/tops',
        exact: false,
        render: (props) => loadComponent(() => import('../containers/Tops/Tops'), props),
    },
    {
        path: '/about',
        exact: false,
        render: (props) => loadComponent(() => import('../containers/About/About'), props),
    },
]



// WEBPACK FOOTER //
// ./src/config/routes.js